export function SpaceDto() {
	this.Width = 0;
	this.Length = 0;
	this.IsNegative = false;
	this.Factor = 1;
	this.PlasterDeduction = 0;
	this.LivingValueApproach = 1;
	this.IsAreaPart = true;
}